import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 71028 60398"
    {...props}
  >
    <defs>
      <style>
        {".str0{stroke:#000;stroke-width:1029.39}.fil0{fill:#2b2a29}"}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_2528317597888">
        <path
          d="M66509 3149H4520c-269 0-487-217-487-486s218-486 487-486h61989c269 0 486 217 486 486s-217 486-486 486z"
          className="fill stroke1"
          style={{
            strokeWidth: 1029.39,
          }}
        />
        <path
          d="M2664 1486c-649 0-1177 529-1177 1177 0 649 528 1177 1176 1177 650 0 1177-528 1177-1177 0-648-527-1177-1176-1177zm0 3325c-1186 0-2149-963-2149-2148S1478 515 2663 515c1185-1 2149 963 2149 2148s-964 2148-2148 2148zM68365 1486c-648 0-1177 529-1177 1177 0 649 528 1177 1177 1177s1177-528 1177-1177c0-648-528-1177-1177-1177zm0 3325c-1185 0-2149-963-2149-2148 1-1185 963-2148 2149-2148 1185-1 2148 963 2148 2148s-964 2148-2148 2148zM16325 3149c-230 0-435-165-477-401l-5-22c-42-265 138-515 403-557 265-43 514 137 558 401l2 9c45 264-131 516-395 563-29 5-57 8-86 7zM24520 11086c-269 0-486-218-486-485v-1c0-269 217-487 486-487s486 218 486 487c1 267-217 486-486 486z"
                    className="fill stroke1"
          style={{
            strokeWidth: 1029.39,
          }}

        />
        <path
          d="M35215 12526c-5186 0-10068-984-13748-2769-3793-1841-5882-4328-5882-7005 1-34 0-69 1-103 8-264 224-472 486-472h14c270 8 480 233 473 500-1 25-1 51-1 75 0 2284 1894 4461 5333 6130 3550 1722 8283 2671 13324 2671 5039 0 9772-948 13322-2671 3440-1669 5333-3846 5333-6130 1-24 0-50-1-75-7-267 204-492 473-500h14c263 0 478 209 486 472 1 34 1 69 1 103 0 2677-2089 5164-5881 7005-3681 1785-8563 2769-13747 2769z"
                    className="fill stroke1"
          style={{
            strokeWidth: 1029.39,
          }}

        />
        <path
          d="M35215 7488c-4001 0-7814-674-10738-1898-2815-1178-3619-2366-3751-2592l-142-242 138-243c27-49 58-95 83-129 153-219 457-273 676-118 138 96 211 252 207 409 285 344 1123 1164 3164 2017 2809 1176 6489 1823 10363 1823 3872 0 7552-647 10361-1823 2041-853 2879-1673 3164-2017-3-157 69-313 207-409 220-155 523-101 677 118 25 34 56 80 82 129l138 243-141 242c-133 226-936 1414-3752 2592-2924 1224-6737 1898-10736 1898z"
                    className="fill stroke1"
          style={{
            strokeWidth: 1029.39,
          }}

        />
        <path
          d="M35215 17209c-5879 0-11489-1149-15793-3238-2388-1158-4320-2574-5743-4206-1817-2086-2778-4510-2778-7013 0-34 0-69 1-103 8-264 225-472 486-472h15c268 8 479 233 471 500 0 25-1 51-1 75 1 2264 878 4468 2539 6374 1337 1533 3165 2870 5434 3971 4176 2025 9634 3141 15369 3141 5734 0 11192-1116 15367-3141 2269-1101 4098-2438 5434-3971 1662-1906 2539-4110 2539-6374 0-24 0-50-1-75-8-267 204-492 472-500 271-7 492 204 501 472 1 34 0 69 0 103 1 2503-961 4927-2777 7013-1423 1632-3356 3048-5744 4206-4305 2089-9913 3238-15791 3238zM8177 59880c-268 0-486-217-486-486V2663c0-269 217-486 485-486 269 0 487 217 487 486v56731c0 269-218 486-486 486z"
                    className="fill stroke1"
          style={{
            strokeWidth: 1029.39,
          }}

        />
        <path
          d="M11386 43296c-101 0-205-32-292-99-214-161-257-466-95-680 5960-7868 6696-20651 6264-29989-12-268 196-495 463-508 271-12 496 195 509 463 438 9499-326 22522-6461 30621-95 126-241 192-388 192zM13918 43296c-148 0-294-67-390-195-160-215-116-520 100-681 9113-6798 11040-18383 11053-26904 0-268 217-485 486-485 268 0 485 218 485 487-12 8743-2007 20643-11442 27682-88 65-191 96-292 96zM62852 59880c-269 0-487-217-487-486l1-56731c0-269 217-486 486-486 268 0 486 217 486 486v56731c0 269-218 486-486 486zM59642 43296c-147 0-292-66-388-192-6135-8099-6899-21122-6461-30621 14-268 236-475 509-463 268 13 476 240 463 508-431 9338 304 22121 6263 29989 163 214 120 519-94 680-87 67-190 99-293 99h1zM57110 43296c-101 0-203-31-291-96-9436-7039-11431-18939-11443-27682 0-269 217-487 484-487h2c269 0 486 217 486 485 12 8521 1939 20106 11053 26904 214 161 259 466 99 681-96 128-242 195-390 195z"
                    className="fill stroke1"
          style={{
            strokeWidth: 1029.39,
          }}

        />
        <path
          d="M8663 44694h8742c381 0 692-310 692-692 0-380-312-691-693-691H8663v1383zm8742 973H7691v-3328h9714c917 0 1663 746 1663 1663 2 919-746 1665-1663 1665z"
                    className="fill stroke1"
          style={{
            strokeWidth: 1029.39,
          }}

        />
        <path
          d="M12443 59512c-1138 0-2635-570-4519-1716-229-140-302-438-162-668 140-229 438-302 667-162 2483 1509 4205 1943 4980 1256 920-814 807-3326-317-7071-898-2993-2135-5742-2147-5770-111-245-3-532 241-644 245-110 534-2 644 243 13 28 1274 2829 2191 5882 1295 4316 1306 6961 32 8088-423 374-957 562-1610 562z"
                    className="fill stroke1"
          style={{
            strokeWidth: 1029.39,
          }}

        />
        <path
          d="M17068 59883c-874 0-1992-352-3371-1059-240-122-334-415-212-654 123-239 415-334 655-211 1904 975 3253 1204 3797 648 377-386 1023-1865-1105-7262-1214-3078-2735-5906-2751-5933-128-237-40-531 197-659 235-128 531-39 658 196 16 29 1562 2900 2797 6032 1746 4423 2040 7140 899 8306-388 396-907 596-1564 596zM53624 43311c-382 0-693 311-693 691 1 382 311 692 693 692h8742v-1383h-8742zm9714 2356h-9714c-917 0-1664-746-1664-1665 0-917 746-1663 1664-1663h9714v3328z"
                    className="fill stroke1"
          style={{
            strokeWidth: 1029.39,
          }}

        />
        <path
          d="M58585 59512c-653 0-1188-187-1610-562-1274-1127-1263-3772 33-8088 916-3053 2177-5854 2189-5882 111-245 399-353 644-243 245 112 354 399 243 644-12 28-1251 2777-2148 5770-1124 3745-1236 6257-317 7071 776 687 2498 253 4979-1256 231-140 530-67 668 162 140 230 67 528-162 668-1884 1146-3382 1716-4519 1716z"
                    className="fill stroke1"
          style={{
            strokeWidth: 1029.39,
          }}

        />
        <path
          d="M53960 59883c-657 0-1176-200-1564-596-1140-1166-846-3883 898-8306 1236-3132 2782-6003 2798-6032 127-236 422-324 658-196 237 128 325 422 197 659-15 27-1537 2855-2752 5933-2127 5397-1481 6876-1104 7262 544 556 1893 327 3797-648 240-123 533-28 655 211 123 239 27 532-211 654-1380 706-2498 1059-3372 1059z"
                    className="fill stroke1"
          style={{
            strokeWidth: 1029.39,
          }}

        />
      </g>
    </g>
  </svg>
);
export default SvgComponent;
